export default __webpack_public_path__ + "static/media/signin-background-one.37a1f45b.jpg";